import { useQuery } from '@tanstack/react-query';

import { listUsers } from '~/services/AgentHub/AgentService';

import { ListUserParams } from '~/types/services/agentHub';

export const agencyUsersQueryKeys = {
  all: ['agency-users'] as const,
  lists: () => [...agencyUsersQueryKeys.all, 'list'] as const,
  list: (params: ListUserParams) => [...agencyUsersQueryKeys.lists(), params] as const,
};

interface UseListAgencyUsersOptions {
  enabled?: boolean;
}

export function useListAgencyUsers(params: ListUserParams, options: UseListAgencyUsersOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    placeholderData: (prev) => {
      return {
        rows: prev?.rows ?? [],
        total: prev?.total ?? 0,
      };
    },
    queryKey: agencyUsersQueryKeys.list(params),
    queryFn: async () => {
      return await listUsers(params);
    },
    enabled: enabled && !!params.agencyId,
  });
}
